import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

import colors from '../../../styles/colors';
import Tabs from '../../components/Tabs';
import ColoredHeader from '../../components/ColoredHeader';

const Title = styled(Typography)({
  fontWeight: 'bold',
  fontSize: 24,
  marginBottom: 30,
});

const StyledHeader = styled(ColoredHeader)({
  '&:after': { height: 42 },
});

const StyledTabs = styled(Tabs)({
  flex: 1,
  borderColor: colors.base.primary,
  '& .Mui-selected': {
    backgroundColor: colors.base.primary,
  },
});

const GridLayout = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: theme.spacing(3),
  alignItems: 'flex-start',
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: '1fr 1fr',
  },
}));

export {
  Title,
  StyledHeader,
  StyledTabs,
  GridLayout,
};
